import React from 'react';
import './display.css';
import CentumInput from '../../../Input/CentumInput';
import CentumSelect from '../../../Select/CentumSelect';
import { ShSettings } from '../../ShSetup';
import { Context } from 'components/MainPage/dcs/centumvp/ContextVP';

function DisplayComponent({ config, updateConfig }: ShSettings) {
    const [selectedMode, setSelectedMode] = React.useState(true);
    const tempConfig = React.useMemo(() => ({ ...config }), [config]);

    const NumberOfContainerWindows = [1, 2, 3, 4, 5];
    const NumberOfPopupWin = [1, 2, 3, 4];
    const NumberOfFrames = [1, 2, 3, 4, 5];

    const { Display } = tempConfig;
    const { FullScreenMode, WindowMode } = Display;

    const SelectMode = (mode: string) => {
        const isWindowMode = mode === 'Window Mode';
        tempConfig.Display.WindowMode.Enable = isWindowMode;
        tempConfig.Display.FullScreenMode.Enable = !isWindowMode;
        updateConfig(tempConfig);
    };

    const handleInputChange = (type: 'WindowMode' | 'FullScreenMode', field: string, value: number) => {
        tempConfig.Display[type][field] = value;
        updateConfig(tempConfig);
    };

    const handleCheckboxChange = (field: string, value: boolean) => {
        tempConfig.Display.FullScreenMode[field] = value;
        updateConfig(tempConfig);
    };

    return (
        <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ width: '40%', margin: '10px 5px 5px 10px' }}>
                <div className="operation-screen-mode">
                    <div className="window-mode-menu">
                        <div className="label">
                            <CentumInput
                                type="radio"
                                id="Window Mode"
                                name="operation-screen-mode"
                                checked={WindowMode.Enable}
                                onChange={() => SelectMode('Window Mode')}
                            />
                            <div>Window Mode</div>
                        </div>
                        <div className="window-mode-menu__settings">
                            <div>
                                <div>Number of Container windows</div>
                                <CentumSelect
                                    value={WindowMode.NumberOfContainerWindows}
                                    options={NumberOfContainerWindows}
                                    onChange={(value) =>
                                        handleInputChange('WindowMode', 'NumberOfContainerWindows', +value)
                                    }
                                    width={40}
                                    height={20}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="full-screen-mode">
                        <div className="label">
                            <CentumInput
                                type="radio"
                                id="Full Screen Mode"
                                name="operation-screen-mode"
                                checked={FullScreenMode.Enable}
                                onChange={() => SelectMode('Full Screen Mode')}
                            />
                            <div>Full Screen Mode</div>
                        </div>
                        <div className="full-screen-mode__settings">
                            <div>
                                <div>Number of Pop-Up Windows</div>
                                <CentumSelect
                                    value={FullScreenMode.NumberOfPopUpWindows}
                                    options={NumberOfPopupWin}
                                    onChange={(value) =>
                                        handleInputChange('FullScreenMode', 'NumberOfPopUpWindows', +value)
                                    }
                                    width={40}
                                    height={20}
                                />
                            </div>
                            <div>
                                <div>Number of Frames</div>
                                <CentumSelect
                                    value={FullScreenMode.NumberOfFrames}
                                    options={NumberOfFrames}
                                    onChange={(value) => handleInputChange('FullScreenMode', 'NumberOfFrames', +value)}
                                    width={40}
                                    height={20}
                                />
                            </div>
                            <div>
                                <CentumInput
                                    checked={FullScreenMode.UseFaceplateFrameAsDefault}
                                    id="UseFaceplateFrameAsDefault"
                                    type="checkbox"
                                    onChange={handleCheckboxChange}
                                />
                                <div>Use faceplate frame as a default</div>
                            </div>
                            <div>
                                <CentumInput
                                    checked={FullScreenMode.ShowCloseButtonOnEachView}
                                    id="ShowCloseButtonOnEachView"
                                    type="checkbox"
                                    onChange={handleCheckboxChange}
                                />
                                <div>Show close button on each view</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="font">
                    {['FontMode1', 'FontMode2'].map((id) => (
                        <CentumInput
                            key={id}
                            type="radio"
                            id={id}
                            name="font-mode"
                            // onChange={() => setSelectedMode(id)}
                        />
                    ))}
                </div>
            </div>
            <div style={{ width: '60%', margin: '10px 10px 5px 5px' }}>
                <div className="status-display"></div>
                <div style={{ height: '45%' }}></div>
                <div className="title-format"></div>
            </div>
        </div>
    );
}

export default DisplayComponent;
